import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { HelpCircle } from 'lucide-react';

const LEGEND_ENTRIES: Array<{ term: string; meaning: string }> = [
  { term: 'Total in feed', meaning: "Every product listed in the site's feed file, whether or not anything changed." },
  { term: 'New', meaning: "A product we didn't have in our catalog before this import." },
  { term: 'Updated', meaning: 'A product we already had, where the feed\'s data changed since last time.' },
  { term: 'Unchanged', meaning: 'A product we already had where nothing changed — normally skipped from further processing.' },
  { term: 'Enriched', meaning: 'Whether our AI successfully pulled structured details (material, size, specs) out of the raw feed text.' },
  { term: 'Embedded', meaning: 'Whether we successfully computed the "fingerprint" used to find comparable products and answer questions.' },
  { term: 'AEO pages written', meaning: 'Pages actually generated and saved this run (excludes cached/unchanged products already up to date).' },
  { term: 'Validated', meaning: 'Generated content that passed automated quality checks — ready to publish.' },
  { term: 'Needs Review', meaning: 'Generated, but a quality check flagged it for a human look before publishing.' },
  { term: 'Needs Research', meaning: "Blocked — we don't yet have enough category-level research to safely generate this product's content." },
  { term: 'Failed', meaning: 'Generation was attempted but hit a technical error (not a quality judgment).' },
  { term: 'Skipped', meaning: 'Generation was intentionally not attempted (e.g. unchanged product on a non-forced run).' },
];

export function FunnelLegend() {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" aria-label="What do these terms mean?" className="inline-flex items-center text-muted-foreground hover:text-foreground">
          <HelpCircle className="h-4 w-4" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-96 max-h-96 overflow-y-auto">
        <dl className="space-y-2 text-sm">
          {LEGEND_ENTRIES.map((entry) => (
            <div key={entry.term}>
              <dt className="font-semibold">{entry.term}</dt>
              <dd className="text-muted-foreground">{entry.meaning}</dd>
            </div>
          ))}
        </dl>
      </PopoverContent>
    </Popover>
  );
}
